import React, { Component } from 'react';
import { AuthLogic } from '../auth/AuthLogic';
import queryString from 'query-string';

class SilentCallback extends Component {
    async checkAuth() {
        const result = queryString.parse(window.location.hash);

        await AuthLogic.getInstance().handleAuthentication(
            {
                accessToken: result.access_token,
                idToken: result.id_token
                // tslint:disable-next-line:no-any
            } as any,
            result.expires_in,
            result.scope
        );
    }

    async componentDidMount() {
        await this.checkAuth();
    }

    render() {
        return <script type="text/javascript" />;
    }
}

export default SilentCallback;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/SilentCallback.tsx